import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DataForm from "./DataForm";
import { Box, Grid } from "@mui/material";
import MultiLineChart from "./MultiLineChart";
import ColumnChart from "./ColumnChart";
import DataTable from "./DataTable";
import ExportIcons from "./ExportIcons";
import CollapseSection from "../../../components/ui/CollapseSection";
import ChartTableToggle from "./ChartTableToggle";
import AnalyzeTable from "./AnalyzeTable";

export default function Data() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const {
    multiLineChartDataPrepared,
    columnChartDataPrepared,
    tableDataPrepared,
    clearAnalyzeData,
  } = state;

  return (
    <Box>
      <DataForm />

      {multiLineChartDataPrepared !== null &&
        columnChartDataPrepared !== null &&
        tableDataPrepared !== null &&
        clearAnalyzeData && (
          <>
            <CollapseSection title="Analyze Data">
             
              <Grid sx={{ mt: 0.5 }} columns={12} container spacing={2}>
              <Grid item xs={10} lg={5}>
              <ChartTableToggle item lg={1}/>
              </Grid>
              <Grid item xs={10} lg={7}>
              <ExportIcons item lg={11}/>
              </Grid>
                <Grid item md={7} lg={7}>
                  
                  <MultiLineChart />
                  <AnalyzeTable />
                </Grid>
                <Grid item md={5} lg={5}>
                  <ColumnChart />
                </Grid>
              </Grid>
            </CollapseSection>
            <DataTable />
          </>
        )}
    </Box>
  );
}
